"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMutableMemoryValue = exports.useMemoryValue = exports.StoredMemoryValue = exports.SecureStoredMemoryValue = exports.MemoryValue = exports.disableWarnings = void 0;
var react_1 = require("react");
var react_fast_compare_1 = __importDefault(require("react-fast-compare"));
var secure_1 = require("./secure");
var storage_1 = require("./storage");
var warningDisabled = false;
function disableWarnings() {
    warningDisabled = true;
}
exports.disableWarnings = disableWarnings;
function warn() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (warningDisabled) {
        return;
    }
    console.warn.apply(console, __spreadArray(['[expo-use-memory-value]'], args, false));
}
var MemoryValue = /** @class */ (function () {
    function MemoryValue(initial) {
        this.listeners = [];
        this.value = initial;
    }
    Object.defineProperty(MemoryValue.prototype, "current", {
        get: function () {
            return this.value;
        },
        enumerable: false,
        configurable: true
    });
    MemoryValue.prototype.subscribe = function (listener, emit) {
        var _this = this;
        if (emit === void 0) { emit = true; }
        if (this.value !== undefined && emit) {
            listener(this.value);
        }
        this.listeners.push(listener);
        return function () { return _this.unsubscribe(listener); };
    };
    MemoryValue.prototype.unsubscribe = function (listener) {
        var index = this.listeners.indexOf(listener);
        if (index >= 0) {
            this.listeners.splice(index, 1);
        }
    };
    MemoryValue.prototype.emit = function (value, _store, newOnly) {
        if (_store === void 0) { _store = false; }
        if (newOnly === void 0) { newOnly = true; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (newOnly && (0, react_fast_compare_1.default)(this.value, value)) {
                            return [2 /*return*/, value];
                        }
                        this.value = value;
                        return [4 /*yield*/, Promise.all(this.listeners.map(function (listener) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                                return [2 /*return*/, listener(value)];
                            }); }); }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, value];
                }
            });
        });
    };
    return MemoryValue;
}());
exports.MemoryValue = MemoryValue;
var SecureStoredMemoryValue = /** @class */ (function () {
    function SecureStoredMemoryValue(storageKey, hydrate, initial) {
        if (hydrate === void 0) { hydrate = true; }
        this.storageKey = storageKey;
        this.value = new MemoryValue(initial);
        this.storageKey = storageKey;
        if (hydrate) {
            this.hydrate();
        }
    }
    Object.defineProperty(SecureStoredMemoryValue.prototype, "current", {
        get: function () {
            return this.value.current;
        },
        enumerable: false,
        configurable: true
    });
    SecureStoredMemoryValue.prototype.subscribe = function (listener, emit) {
        if (emit === void 0) { emit = true; }
        return this.value.subscribe(listener, emit);
    };
    SecureStoredMemoryValue.prototype.unsubscribe = function (listener) {
        return this.value.unsubscribe(listener);
    };
    SecureStoredMemoryValue.prototype.emit = function (value, store, newOnly) {
        if (store === void 0) { store = true; }
        if (newOnly === void 0) { newOnly = true; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (newOnly && (0, react_fast_compare_1.default)(value, this.current)) {
                            return [2 /*return*/, value];
                        }
                        if (!store) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.write(value)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.value.emit(value, false, false)];
                }
            });
        });
    };
    SecureStoredMemoryValue.prototype.hydrate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, secure_1.getItemAsync)(this.storageKey).then(function (value) {
                        if (value) {
                            return _this.emit(value, false);
                        }
                        else {
                            return _this.emit(null, false);
                        }
                    }, function () {
                        return _this.value;
                    })];
            });
        });
    };
    SecureStoredMemoryValue.prototype.write = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (value === undefined) {
                    return [2 /*return*/, this.clear()];
                }
                return [2 /*return*/, (0, secure_1.setItemAsync)(this.storageKey, value).catch(warn)];
            });
        });
    };
    SecureStoredMemoryValue.prototype.clear = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, secure_1.deleteItemAsync)(this.storageKey).catch(warn)];
            });
        });
    };
    return SecureStoredMemoryValue;
}());
exports.SecureStoredMemoryValue = SecureStoredMemoryValue;
var StoredMemoryValue = /** @class */ (function () {
    function StoredMemoryValue(storageKey, hydrate, initial) {
        if (hydrate === void 0) { hydrate = true; }
        this.storageKey = storageKey;
        this.value = new MemoryValue(initial);
        this.storageKey = storageKey;
        if (hydrate) {
            this.hydrate();
        }
    }
    Object.defineProperty(StoredMemoryValue.prototype, "current", {
        get: function () {
            return this.value.current;
        },
        enumerable: false,
        configurable: true
    });
    StoredMemoryValue.prototype.subscribe = function (listener, emit) {
        if (emit === void 0) { emit = true; }
        return this.value.subscribe(listener, emit);
    };
    StoredMemoryValue.prototype.unsubscribe = function (listener) {
        return this.value.unsubscribe(listener);
    };
    StoredMemoryValue.prototype.emit = function (value, store, newOnly) {
        if (store === void 0) { store = true; }
        if (newOnly === void 0) { newOnly = true; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (newOnly && (0, react_fast_compare_1.default)(value, this.current)) {
                            return [2 /*return*/, value];
                        }
                        if (!store) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.write(value)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.value.emit(value, false, false)];
                }
            });
        });
    };
    StoredMemoryValue.prototype.hydrate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, storage_1.getItemAsync)(this.storageKey).then(function (value) {
                        if (value) {
                            return _this.emit(value, false);
                        }
                        else {
                            return _this.emit(null, false);
                        }
                    }, function () {
                        return _this.value;
                    })];
            });
        });
    };
    StoredMemoryValue.prototype.write = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (value === undefined) {
                    return [2 /*return*/, this.clear()];
                }
                return [2 /*return*/, (0, storage_1.setItemAsync)(this.storageKey, value).catch(warn)];
            });
        });
    };
    StoredMemoryValue.prototype.clear = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, storage_1.deleteItemAsync)(this.storageKey).catch(warn)];
            });
        });
    };
    return StoredMemoryValue;
}());
exports.StoredMemoryValue = StoredMemoryValue;
function useMemoryValue(value) {
    return useMutableMemoryValue(value)[0];
}
exports.useMemoryValue = useMemoryValue;
function useMutableMemoryValue(value) {
    var _a = (0, react_1.useState)(value.current), state = _a[0], setState = _a[1];
    var update = (0, react_1.useCallback)(function (nextValue) {
        if (nextValue instanceof Function || typeof nextValue === 'function') {
            value.emit(nextValue(value.current));
        }
        else {
            value.emit(nextValue);
        }
    }, [value]);
    (0, react_1.useLayoutEffect)(function () {
        return value.subscribe(setState);
    }, [value, setState]);
    return [state, update];
}
exports.useMutableMemoryValue = useMutableMemoryValue;
